export const keys = {
	what_you_do: 'what_you_do',
	applicable_profession: 'applicable_profession',
	retailer: 'retailer',
	retailer_descp: 'retailer_descp',
	distributer: 'distributer',
	distributer_descp: 'distributer_descp',
	farmer: 'farmer',
	farmer_descp: 'farmer_descp',
	download_app_now: 'download_app_now',
	not_now: 'not_now',
	get_the_app: 'get_the_app',
	rake: 'rake',
	bahi_khata: 'bahi_khata',
	distributor: 'distributor',
	dukaan_prachar: 'dukaan_prachar',
	crop_advisory: 'crop_advisory',
	rake_card_text: 'rake_card_text',
	bahi_khata_card_text: 'bahi_khata_card_text',
	distributor_card_text: 'distributor_card_text',
	dukaan_prachar_card_text: 'dukaan_prachar_card_text',
	crop_advisory_card_text: 'crop_advisory_card_text',
	choose_role: 'choose_role',
	change_role: 'change_role',
	sms_feature: 'sms_feature',
	sell_crop_primary_heading: 'sell_crop_primary_heading',
	expense_manager_primary_heading: 'expense_manager_primary_heading',
	mandi_rate_primary_heading: 'mandi_rate_primary_heading',
	distributor_list: 'distributor_list',
	crop_advisory_primary_heading: 'crop_advisory_primary_heading',
	crop_advisory_primary_sub_heading: 'crop_advisory_primary_sub_heading',
	crop_advisory_fomo_primary: 'crop_advisory_fomo_primary',
	crop_advisory_primary_button: 'crop_advisory_primary_button',
	subscribe_new_crop: 'subscribe_new_crop',
	sms_primary_heading: 'sms_primary_heading',
	sms_primary_sub_heading: 'sms_primary_sub_heading',
	sms_fomo_primary: 'sms_fomo_primary',
	sms_balance: 'sms_balance',
	sms_primary_button: 'sms_primary_button',
	bahi_khata_primary_sub_heading: 'bahi_khata_primary_sub_heading',
	bahi_khata_fomo_primary: 'bahi_khata_fomo_primary',
	bahi_khata_credit_text: 'bahi_khata_credit_text',
	bahi_khata_debit_text: 'bahi_khata_debit_text',
	bahi_khata_primary_button: 'bahi_khata_primary_button',
	rake_primary_sub_heading: 'rake_primary_sub_heading',
	rake_fomo_primary: 'rake_fomo_primary',
	rake_primary_button: 'rake_primary_button',
	rake_unavailable: 'rake_unavailable',
	rake_available_heading: 'rake_available_heading',
	rake_location_unavailable_text: 'rake_location_unavailable_text',
	rake_reached: 'rake_reached',
	rake_status: 'rake_status',
	weather_rain_90: 'weather_rain_90',
	weather_rain_70: 'weather_rain_70',
	weather_rain_30: 'weather_rain_30',
	weather_wind_25: 'weather_wind_25',
	weather_wind_12: 'weather_wind_12',
	weather_max_temp: 'weather_max_temp',
	weather_min_temp: 'weather_min_temp',
	weather_no_location: 'weather_no_location',
	weather_normal: 'weather_normal',
	share: 'share',
	good_food_economy: 'good_food_economy',
	good_food_logo_text: 'good_food_logo_text',
	community: 'community',
	view_all_news_feed: 'view_all_news_feed',
	see_more: 'see_more',
	clap: 'clap',
	comment: 'comment',
	jan: 'jan',
	feb: 'feb',
	march: 'march',
	april: 'april',
	may: 'may',
	june: 'june',
	july: 'july',
	august: 'august',
	september: 'september',
	october: 'october',
	november: 'november',
	december: 'december',
	change_location_text: 'change_location_text',
	weather_greeting: 'weather_greeting',
	weather_whatsapp_link: 'weather_whatsapp_link',
	quiz: 'quiz',
	quiz_card_text: 'quiz_card_text',
	add_farmer: 'add_farmer',
	help: 'help',
	gk_quiz_header_text: 'gk_quiz_header_text',
	gk_quiz_message_text: 'gk_quiz_message_text',
	gk_quiz_sub_message_text: 'gk_quiz_sub_message_text',
	whatsapp_install: 'whatsapp_install',
	location_enable_text: 'location_enable_text',
	refresh_page_message: 'refresh_page_message',

	login_text: 'login_text',
	login_heading: 'login_heading',
	number_input_title: 'number_input_title',
	terms_and_conditions: 'terms_and_conditions',
	select_language_button: 'select_language_button',
	change_language: 'change_language',
	notification_language: 'notification_language',
	select_notification_language: 'select_notification_language',
	proceed: 'proceed',
	select_language: 'select_language',
	farmart_moto_label: 'farmart_moto_label',

	otp_title: 'otp_title',
	otp_sent_on_mobile: 'otp_sent_on_mobile',
	change_number: 'change_number',
	otp_error_message: 'otp_error_message',
	did_not_get_otp: 'did_not_get_otp',
	send_again: 'send_again',
	otp_never_share_otp: 'otp_never_share_otp',
	otp_submit_title: 'otp_submit_title',
	otp_submit_sent_to: 'otp_submit_sent_to',
	otp_submit_update: 'otp_submit_update',
	otp_submit_resend: 'otp_submit_resend',
	otp_submit_resend_in: 'otp_submit_resend_in',
	otp_submit_never_share_detail: 'otp_submit_never_share_detail',
	otp_submit_input_placeholder: 'otp_submit_input_placeholder',
	mobile_number_copytext: 'mobile_number_copytext',
	wrong_otp: 'wrong_otp',

	congrats_heading_text: 'congrats_heading_text',
	congrats_sub_heading_text: 'congrats_sub_heading_text',
	proceed_button_text: 'proceed_button_text',

	heading_add_farmer: 'heading_add_farmer',
	search_place_holder: 'search_place_holder',
	empty_state: 'empty_state',
	contact_alert: 'contact_alert',
	manual_farmer_button: 'manual_farmer_button',
	denied_permission_alert_heading: 'denied_permission_alert_heading',
	denied_permission_alert_sub_heading: 'denied_permission_alert_sub_heading',
	manual_modal_heading: 'manual_modal_heading',
	farmer_name_input_title: 'farmer_name_input_title',
	farmer_name_input_place_holder: 'farmer_name_input_place_holder',
	farmer_number_input_title: 'farmer_number_input_title',
	farmer_number_input_place_holder: 'farmer_number_input_place_holder',
	manual_submit_button: 'manual_submit_button',
	add_farmer_button: 'add_farmer_button',
	web_alert_text: 'web_alert_text',
	download_app_button: 'download_app_button',
	api_error: 'api_error',

	heading_your_farmer: 'heading_your_farmer',
	search_text: 'search_text',
	delete: 'delete',
	no_search: 'no_search',
	add_new_farmer_button: 'add_new_farmer_button',
	delete_button_text: 'delete_button_text',
	close: 'close',
	delete_heading: 'delete_heading',
	empty_alert: 'empty_alert',
	delete_modal: 'delete_modal',

	pending_rake_message: 'pending_rake_message',
	reached_rake_message: 'reached_rake_message',
	header_title: 'header_title',
	no_rake_available: 'no_rake_available',
	no_current_rake: 'no_current_rake',
	near_area_raketitle: 'near_area_raketitle',
	see_in_more_district: 'see_in_more_district',
	rake_message1: 'rake_message1',
	rake_message2: 'rake_message2',
	help_rake_detail: 'help_rake_detail',

	heading_rake_information: 'heading_rake_information',
	help_text: 'help_text',
	location_modal_heading: 'location_modal_heading',
	location_modal_descp_sub_heading: 'location_modal_descp_sub_heading',
	location_modal_gps_button: 'location_modal_gps_button',
	location_modal_divider_text: 'location_modal_divider_text',
	pin_code_button_heading: 'pin_code_button_heading',
	pin_code_button_title: 'pin_code_button_title',
	view_near_by_rake: 'view_near_by_rake',
	current_rake_count: 'current_rake_count',
	view_rake: 'view_rake',
	rake_text: 'rake_text',
	view_more_near_rake: 'view_more_near_rake',
	rake_type_agri_input: 'rake_type_agri_input',
	rake_type_food_grain: 'rake_type_food_grain',

	no_whats_app_account_found: 'no_whats_app_account_found',
	whats_app_message_text: 'whats_app_message_text',

	help_and_support: 'help_and_support',
	frequently_asked_questions: 'frequently_asked_questions',

	error_mobile_number: 'error_mobile_number',
	trade: 'trade',
	rapid_trade: 'rapid_trade',
	connect_with_us: 'connect_with_us',
	near_soon: 'near_soon',
	block_user_message: 'block_user_message',
	mobile_number_copied: 'mobile_number_copied',
	last_update: 'last_update',
	coming_soon_heading: 'coming_soon_heading',
	coming_soon_sub_heading: 'coming_soon_sub_heading',
	contact_us: 'contact_us',
	no_active_buyer_heading: 'no_active_buyer_heading',
	no_active_buyer_sub_heading: 'no_active_buyer_sub_heading',
	no_expired_buyer: 'no_expired_buyer',
	buyer_price: 'buyer_price',
	expired_price: 'expired_price',
	prices: 'prices',
	crop_modal_heading: 'crop_modal_heading',
	crop_modal_search_placeholder: 'crop_modal_search_placeholder',
	crop_variety_modal_search_placeholder: 'crop_variety_modal_search_placeholder',
	crop_variety_modal_heading: 'crop_variety_modal_heading',
	select_location_heading: 'select_location_heading',
	select_location_search_placeholder: 'select_location_search_placeholder',
	select_location_button: 'select_location_button',
	allow_location: 'allow_location',
	allow_location_heading: 'allow_location_heading',
	view_details: 'view_details',
	kyc_consent_notifications_title: 'kyc_consent_notifications_title',
	connect_to_sell: 'connect_to_sell',
	price_expired: 'price_expired',
	apply: 'apply',
	my_sauda: 'my_sauda',
	request_sauda: 'request_sauda',
	direct_order_banner_headline: 'direct_order_banner_headline',
	direct_order_banner_description: 'direct_order_banner_description',
	direct_order_banner_cta: 'direct_order_banner_cta',
	create_sauda_title: 'create_sauda_title',
	create_sauda_buyer_label: 'create_sauda_buyer_label',
	create_sauda_select_buyer_placeholder: 'create_sauda_select_buyer_placeholder',
	create_sauda_select_buyer_modal_title: 'create_sauda_select_buyer_modal_title',
	create_sauda_select_broker: 'create_sauda_select_broker',
	create_sauda_want_to_add_new_broker: 'create_sauda_want_to_add_new_broker',
	create_sauda_call_pa: 'create_sauda_call_pa',
	create_sauda_select_crop_and_variety: 'create_sauda_select_crop_and_variety',
	create_sauda_want_to_deal_in_new_crop: 'create_sauda_want_to_deal_in_new_crop',
	create_sauda_select_crop: 'create_sauda_select_crop',
	create_sauda_search_crop: 'create_sauda_search_crop',
	create_sauda_search_crop_placeholder: 'create_sauda_search_crop_placeholder',
	request_sauda_with_buyer_price_title: 'request_sauda_with_buyer_price_title',
	request_sauda_with_buyer_price_description:
		'request_sauda_with_buyer_price_description',
	how_it_works: 'how_it_works',
	request_sauda_step_1: 'request_sauda_step_1',
	request_sauda_step_2: 'request_sauda_step_2',
	request_sauda_step_3: 'request_sauda_step_3',
	sauda_already_requested: 'sauda_already_requested',
	sauda_requested: 'sauda_requested',
	callback_requested: 'callback_requested',
	request_callback: 'request_callback',
	no_location: 'no_location',
	change_location: 'change_location',
	allow_location_disclaimer: 'allow_location_disclaimer',
	allow_location_button: 'allow_location_button',
	discount_card_text: 'discount_card_text',
	search_buyer: 'search_buyer',
	active_buyer_prices: 'active_buyer_prices',
	crop_filter_label: 'crop_filter_label',
	crop_filter_all: 'crop_filter_all',
	crop_variety_filter_label: 'crop_variety_filter_label',
	location_filter_label: 'location_filter_label',

	brokerage_pop_up_title: 'brokerage_pop_up_title',
	brokerage_pop_up_sub_heading: 'brokerage_pop_up_sub_heading',
	pop_up_okay_button: 'pop_up_okay_button',
	finance_pop_up_title: 'finance_pop_up_title',
	net_price_pop_up_sub_heading: 'net_price_pop_up_sub_heading',
	net_price_pop_up_title: 'net_price_pop_up_title',
	finance_pop_up_sub_heading: 'finance_pop_up_sub_heading',
	heading_trade_details: 'heading_trade_details',
	buyer_price_details_title: 'buyer_price_details_title',
	buyer_details: 'buyer_details',
	buyer_details_tab: 'buyer_details_tab',
	payment_terms: 'payment_terms',
	price_details: 'price_details',
	buyer_terms: 'buyer_terms',
	grn_terms: 'grn_terms',
	net_price: 'net_price',
	net_for: 'net_for',
	gross_buyer_rate: 'gross_buyer_rate',
	quality_parameters: 'quality_parameters',
	quality_requirement: 'quality_requirement',
	plant_address: 'plant_address',
	unloading_payment: 'unloading_payment',
	delivery_by: 'delivery_by',
	within_days_of_unloading: 'within_days_of_unloading',
	need_help_call: 'need_help_call',
	payment_at_unloading: 'payment_at_unloading',
	payment_at: 'payment_at',
	payment_at_unloading_title: 'payment_at_unloading_title',
	payment_at_unloading_body: 'payment_at_unloading_body',
	call_me_sheet_title: 'call_me_sheet_title',
	call_me_sheet_body: 'call_me_sheet_body',
	call_me_sheet_confirm: 'call_me_sheet_confirm',
	callback_already_requested: 'callback_already_requested',
	map_intro_a11y_label: 'map_intro_a11y_label',
	map_intro_badge_new: 'map_intro_badge_new',
	map_intro_benefit_districts: 'map_intro_benefit_districts',
	map_intro_benefit_plan: 'map_intro_benefit_plan',
	map_intro_maybe_later: 'map_intro_maybe_later',
	map_intro_explore_now: 'map_intro_explore_now',
	map_intro_city_nagpur: 'map_intro_city_nagpur',
	map_intro_city_kanpur: 'map_intro_city_kanpur',
	trade_map_fab_label: 'trade_map_fab_label',
	order_fulfilment_date: 'order_fulfilment_date',
	fulfilment_note: 'fulfilment_note',
	payment_terms_note: 'payment_terms_note',
	gross_price: 'gross_price',
	cash_discount: 'cash_discount',
	bag_deduction: 'bag_deduction',
	unloading_charges: 'unloading_charges',
	brokerage: 'brokerage',
	financing_cost: 'financing_cost',
	financing_fee: 'financing_fee',
	rapid_trade_margin: 'rapid_trade_margin',
	rapid_trade_margin_pop_up_sub_heading: 'rapid_trade_margin_pop_up_sub_heading',
	rapid_trade_net_price_pop_up_sub_heading:
		'rapid_trade_net_price_pop_up_sub_heading',
	processing_fee: 'processing_fee',
	processing_fee_per_truck: 'processing_fee_per_truck',
	moisture: 'moisture',
	foreign_matter: 'foreign_matter',
	damaged: 'damaged',
	buyer_term_tool_tip: 'buyer_term_tool_tip',
	grn_term_tool_tip: 'grn_term_tool_tip',
	discounted_grn_term_tool_tip: 'discounted_grn_term_tool_tip',
	contact_to_sell: 'contact_to_sell',
	quantity_to_sell: 'quantity_to_sell',
	enter_quantity: 'enter_quantity',
	at_buyers_terms: 'at_buyers_terms',
	at_grn_terms: 'at_grn_terms',
	min_quantity_preferred: 'min_quantity_preferred',
	min_quantity_preferred_with_unit: 'min_quantity_preferred_with_unit',
	rapid_trade_min_quantity_error: 'rapid_trade_min_quantity_error',
	submit_request: 'submit_request',
	estimated_value: 'estimated_value',
	sauda_summary: 'sauda_summary',
	net_for_rate: 'net_for_rate',
	processing_fee_deduction_note: 'processing_fee_deduction_note',
	rapid_trade_request_submitted: 'rapid_trade_request_submitted',
	rapid_trade_request_submitted_body: 'rapid_trade_request_submitted_body',
	rapid_trade_success_crop: 'rapid_trade_success_crop',
	rapid_trade_success_quantity: 'rapid_trade_success_quantity',
	rapid_trade_success_buyer: 'rapid_trade_success_buyer',
	rapid_trade_request_failed: 'rapid_trade_request_failed',
	rapid_trade_sauda_requested_body: 'rapid_trade_sauda_requested_body',
	rapid_trade_share_text: 'rapid_trade_share_text',
	choose_payment_terms: 'choose_payment_terms',
	net_price_pop_up_sub_heading2: 'net_price_pop_up_sub_heading2',
	price_warning: 'price_warning',
	buyer_net_price: 'buyer_net_price',
	discount_fee: 'discount_fee',
	saving_amount: 'saving_amount',
	amount_saved_text: 'amount_saved_text',

	my_saudas: 'my_saudas',
	urgent_action_pending: 'urgent_action_pending',
	accept_po: 'accept_po',
	request_create_on: 'request_create_on',
	po_acceptance_pending: 'po_acceptance_pending',
	no_of_trucks_text: 'no_of_trucks_text',
	sauda_completed: 'sauda_completed',
	sauda_in_review: 'sauda_in_review',
	sauda_rejected: 'sauda_rejected',
	sauda_cancelled: 'sauda_cancelled',
	po_rejected: 'po_rejected',
	closed_sauda: 'closed_sauda',
	open_sauda: 'open_sauda',
	all_saudas: 'all_saudas',
	po_accpetance_pending: 'po_accpetance_pending',
	sauda_booked: 'sauda_booked',
	sauda_card_waiting_for_approval: 'sauda_card_waiting_for_approval',
	sauda_card_please_accept_po: 'sauda_card_please_accept_po',
	sauda_card_review_purchase_order: 'sauda_card_review_purchase_order',
	sauda_card_create_dispatch_order: 'sauda_card_create_dispatch_order',
	sauda_card_view_truck: 'sauda_card_view_truck',
	sauda_card_truck: 'sauda_card_truck',
	sauda_card_dispatched: 'sauda_card_dispatched',
	sauda_card_commodity: 'sauda_card_commodity',
	sauda_card_rate: 'sauda_card_rate',
	sauda_card_po_quantity: 'sauda_card_po_quantity',
	sauda_status: 'sauda_status',
	pay_at_grn: 'pay_at_grn',
	pay_at_buyer: 'pay_at_buyer',
	no_saudas_found: 'no_saudas_found',
	start_request_sauda: 'start_request_sauda',
	broker_code_applied: 'broker_code_applied',
	book_sauda_with_farmart: 'book_sauda_with_farmart',
	po_created_on: 'po_created_on',
	to_be_updated: 'to_be_updated',
	search_by_id: 'search_by_id',
	date: 'date',
	select_sauda_booked_date: 'select_sauda_booked_date',
	last_seven_days: 'last_seven_days',
	last_thirty_days: 'last_thirty_days',
	last_six_months: 'last_six_months',
	custom_date: 'custom_date',
	from: 'from',
	to: 'to',
	clear: 'clear',

	po_receipt: 'po_receipt',
	sauda_id_label: 'sauda_id_label',
	quantity_label: 'quantity_label',
	net_price_label: 'net_price_label',
	gross_price_label: 'gross_price_label',
	cancel_sauda_request: 'cancel_sauda_request',
	cancel_sauda_modal_heading: 'cancel_sauda_modal_heading',
	accept_po_label: 'accept_po_label',
	view_po_reciept: 'view_po_reciept',
	tnc_accept_1: 'tnc_accept_1',
	tnc_accept_2: 'tnc_accept_2',
	tnc_accept_3: 'tnc_accept_3',
	cancel_button: 'cancel_button',
	accept_po_button: 'accept_po_button',
	reject_po_label: 'reject_po_label',
	reject_po_button: 'reject_po_button',
	accept_po_note: 'accept_po_note',
	accept_po_card_heading: 'accept_po_card_heading',
	accept_po_card_sub_heading: 'accept_po_card_sub_heading',
	truck_modal_heading: 'truck_modal_heading',
	gross_weight_label: 'gross_weight_label',
	truck_rejected_label: 'truck_rejected_label',
	paid_label: 'paid_label',
	pending_label: 'pending_label',
	gross_payble_label: 'gross_payble_label',
	deduction_label: 'deduction_label',
	payable_label: 'payable_label',
	okay_label: 'okay_label',
	truck_modal_info_heading: 'truck_modal_info_heading',
	buyer_quality_report: 'buyer_quality_report',
	truck_modal_payment_due: 'truck_modal_payment_due',
	truck_modal_trans_detail_heading: 'truck_modal_trans_detail_heading',
	utr_number: 'utr_number',
	tap_to_copy: 'tap_to_copy',
	truck_unload: 'truck_unload',
	truck_dispached: 'truck_dispached',
	sauda_in_review_heading: 'sauda_in_review_heading',
	sauda_in_review_sub_heading: 'sauda_in_review_sub_heading',
	sauda_book_card_heading: 'sauda_book_card_heading',
	sauda_book_card_sub_heading: 'sauda_book_card_sub_heading',
	sauda_book_card_sub_heading_offline: 'sauda_book_card_sub_heading_offline',
	po_rejected_card_heading: 'po_rejected_card_heading',
	po_rejected_card_sub_heading: 'po_rejected_card_sub_heading',
	sauda_canceled_card_heading: 'sauda_canceled_card_heading',
	sauda_canceled_card_sub_heading: 'sauda_canceled_card_sub_heading',
	sauda_reject_card_heading: 'sauda_reject_card_heading',
	sauda_reject_card_sub_heading: 'sauda_reject_card_sub_heading',
	sauda_complete_card_heading: 'sauda_complete_card_heading',
	sauda_complete_card_sub_heading: 'sauda_complete_card_sub_heading',
	truck_detail_heading: 'truck_detail_heading',
	view_payment: 'view_payment',
	sauda_canceled_heading_label: 'sauda_canceled_heading_label',
	sauda_review_heading_label: 'sauda_review_heading_label',
	sauda_rejected_heading_label: 'sauda_rejected_heading_label',
	sauda_bookeded_heading_label: 'sauda_bookeded_heading_label',
	sauda_pending_heading_label: 'sauda_pending_heading_label',
	sauda_po_rejected_heading_label: 'sauda_po_rejected_heading_label',
	sauda_comepleted_heading_label: 'sauda_comepleted_heading_label',
	order_detail_heading: 'order_detail_heading',
	order_detail_note: 'order_detail_note',
	need_help_heading: 'need_help_heading',
	need_help_sub_heading: 'need_help_sub_heading',
	chat_with_us: 'chat_with_us',
	call_now: 'call_now',
	heading_sauda_details: 'heading_sauda_details',
	utr_copy_popup: 'utr_copy_popup',
	at_grn: 'at_grn',
	at_buyers: 'at_buyers',
	pay_at_grn_v2: 'pay_at_grn_v2',
	pay_at_buyer_v2: 'pay_at_buyer_v2',
	dispatched_weight: 'dispatched_weight',
	delivered_weight: 'delivered_weight',
	error_message: 'error_message',
	create_dispatch: 'create_dispatch',
	view_report: 'view_report',
	truck_detail_text: 'truck_detail_text',
	document_approval_pending: 'document_approval_pending',
	document_rejected: 'document_rejected',
	document_rejected_info: 'document_rejected_info',
	re_upload_now: 're_upload_now',
	payable: 'payable',
	waiting_for_approval: 'waiting_for_approval',
	payment_details: 'payment_details',
	broker_code: 'broker_code',
	price_breakup: 'price_breakup',
	tds_label: 'tds_label',
	po_id_label: 'po_id_label',
	tap_to_view_tool_tip: 'tap_to_view_tool_tip',
	view_receipt: 'view_receipt',
	booked_on: 'booked_on',
	dispatched_qty: 'dispatched_qty',
	pending_qty: 'pending_qty',
	grn_approval_pending: 'grn_approval_pending',
	grn_doc_rejected: 'grn_doc_rejected',
	download_receipt: 'download_receipt',
	upload_unloading_documents: 'upload_unloading_documents',
	reupload_unloading_documents: 'reupload_unloading_documents',
	tracking_live: 'tracking_live',
	documents_submitted: 'documents_submitted',
	document_approved: 'document_approved',
	quality_issue: 'quality_issue',
	shortage_issue: 'shortage_issue',
	damaged_bags: 'damaged_bags',
	fulfilment_charges: 'fulfilment_charges',
	total_amount_payable: 'total_amount_payable',
	gst_payable: 'gst_payable',
	gst_applicable_amount: 'gst_applicable_amount',
	cgst: 'cgst',
	sgst: 'sgst',
	igst: 'igst',
	gst_details: 'gst_details',
	paid_gst: 'paid_gst',
	pending_gst: 'pending_gst',
	kilogram: 'kilogram',
	gst_tooltip: 'gst_tooltip',
	gst_lang: 'gst_lang',
	net_weight: 'net_weight',
	net_weight_tooltip: 'net_weight_tooltip',

	confirm_request: 'confirm_request',
	want_to: 'want_to',
	pay_at_buyer_terms: 'pay_at_buyer_terms',
	pay_at_grn_terms: 'pay_at_grn_terms',
	net_price_quantity_info: 'net_price_quantity_info',
	confirm_sauda_request: 'confirm_sauda_request',
	review_confirm_sauda_heading: 'review_confirm_sauda_heading',
	confirm_sauda: 'confirm_sauda',
	total_sauda_value_heading: 'total_sauda_value_heading',
	quality_claim_borne_by: 'quality_claim_borne_by',
	unloading_charges_paid_by: 'unloading_charges_paid_by',
	halting_charges_borne_by: 'halting_charges_borne_by',
	invoice_exact_net_for_note: 'invoice_exact_net_for_note',
	once_confirmed_po_shared: 'once_confirmed_po_shared',
	sauda_request_success_title: 'sauda_request_success_title',
	sauda_request_success_heading: 'sauda_request_success_heading',
	sauda_request_success_subtitle: 'sauda_request_success_subtitle',
	sauda_requested_successfully: 'sauda_requested_successfully',
	view_sauda_summary: 'view_sauda_summary',
	sale_details: 'sale_details',
	doc_requirement_title: 'doc_requirement_title',
	gst_or_pan: 'gst_or_pan',
	canceled_cheque: 'canceled_cheque',
	tds: 'tds',
	aadhar_card: 'aadhar_card',
	do_you_have_broker_code: 'do_you_have_broker_code',
	enter_broker_code: 'enter_broker_code',
	unverified_broker_code: 'unverified_broker_code',
	invalid_broker_code: 'invalid_broker_code',
	verified_broker_code: 'verified_broker_code',
	invalid_broker_code_alert: 'invalid_broker_code_alert',
	sauda_price_and_quantity: 'sauda_price_and_quantity',
	amount_saved: 'amount_saved',
	total_sauda_value: 'total_sauda_value',
	pay_at_unloading: 'pay_at_unloading',
	gross_buyer_price: 'gross_buyer_price',
	net_buyer_price: 'net_buyer_price',
	farmart_fee: 'farmart_fee',
	discounted_farmart_fee: 'discounted_farmart_fee',
	net_for_price: 'net_for_price',

	send_to_farmers: 'send_to_farmers',
	enter_your_own_rate: 'enter_your_own_rate',
	rate_input_placeholder: 'rate_input_placeholder',
	or: 'or',
	uchit_mulya: 'uchit_mulya',
	fair_price_sms_value: 'fair_price_sms_value',
	fertilizer_rate: 'fertilizer_rate',
	crop_rate: 'crop_rate',
	seed_rate: 'seed_rate',
	crop_name: 'crop_name',
	search_crop: 'search_crop',
	fertilizer_name: 'fertilizer_name',
	search_fertilizer: 'search_fertilizer',
	sms_balance_left: 'sms_balance_left',

	heading_shop_promotion: 'heading_shop_promotion',
	sms_history: 'sms_history',
	current_sms_balance: 'current_sms_balance',
	free_sms_every_month_info: 'free_sms_every_month_info',
	sms_credits_expiring_today: 'sms_credits_expiring_today',
	sms_credits_expiring_tomorrow: 'sms_credits_expiring_tomorrow',
	sms_credits_expiring_in_days: 'sms_credits_expiring_in_days',
	select_sms_template: 'select_sms_template',
	promotional_media_container_heading: 'promotional_media_container_heading',
	okay: 'okay',
	need_support: 'need_support',
	reach_out_for_help: 'reach_out_for_help',
	progressive_sign_up_modal_heading: 'progressive_sign_up_modal_heading',
	business_name_input_title: 'business_name_input_title',
	name_input_title: 'name_input_title',
	business_name_input_placeholder: 'business_name_input_placeholder',
	name_input_title_placeholder: 'name_input_title_placeholder',
	progressive_modal_proceed: 'progressive_modal_proceed',
	shop_name_input_title: 'shop_name_input_title',
	shop_name_input_placeholder: 'shop_name_input_placeholder',

	heading_message_details: 'heading_message_details',
	sms_used: 'sms_used',
	sms_sent: 'sms_sent',
	message_sent_title: 'message_sent_title',
	farmer_list_title: 'farmer_list_title',

	heading_your_farmers: 'heading_your_farmers',
	select_all: 'select_all',
	farmers_selected: 'farmers_selected',
	send_farmer_error: 'send_farmer_error',
	sms_recipient_limit_exceeded: 'sms_recipient_limit_exceeded',

	sms_left: 'sms_left',
	pending_heading_text: 'pending_heading_text',
	pending_sub_heading_text: 'pending_sub_heading_text',

	shop_promotion_modal_title: 'shop_promotion_modal_title',
	more_about_balance: 'more_about_balance',
	free_sms_credit_title: 'free_sms_credit_title',
	free_sms_credit_text: 'free_sms_credit_text',
	sms_expiry_title: 'sms_expiry_title',
	sms_expiry_text: 'sms_expiry_text',

	heading_sms_history: 'heading_sms_history',
	sms_history_title: 'sms_history_title',
	buy_more_sms: 'buy_more_sms',
	buy: 'buy',
	sms_plan_messages: 'sms_plan_messages',
	sms_plan_validity: 'sms_plan_validity',
	popular_recharge_packs: 'popular_recharge_packs',
	number_of_d_farmer_got_message: 'number_of_d_farmer_got_message',
	heading_recharge_details: 'heading_recharge_details',
	sms_recharge_success: 'sms_recharge_success',
	sms_added: 'sms_added',
	sms_recharge_verification_pending: 'sms_recharge_verification_pending',
	payment_dismissed_message: 'payment_dismissed_message',
	payment_successful: 'payment_successful',
	sms_recharge_credited_card_heading: 'sms_recharge_credited_card_heading',
	recharge_successful_title: 'recharge_successful_title',
	sms_credited_successfully_subheading: 'sms_credited_successfully_subheading',
	recharge_amount_label: 'recharge_amount_label',
	sms_validity_label: 'sms_validity_label',
	sms_recharge_validity_days: 'sms_recharge_validity_days',
	payment_id_label: 'payment_id_label',
	recharge_amount_rupees: 'recharge_amount_rupees',
	payment_id_not_available: 'payment_id_not_available',
	recharge_amount_not_available: 'recharge_amount_not_available',

	heading_search_location: 'heading_search_location',
	search_place_holder_pincode: 'search_place_holder_pincode',
	no_pincode_text: 'no_pincode_text',

	location_modal_heading_your_location: 'location_modal_heading_your_location',

	header_title_my_profile: 'header_title_my_profile',
	edit_profile_text: 'edit_profile_text',
	change_profile: 'change_profile',
	logout: 'logout',
	privacy_policy: 'privacy_policy',
	feedback: 'feedback',
	nps_question: 'nps_question',
	nps_submit: 'nps_submit',
	nps_very_bad: 'nps_very_bad',
	nps_excellent: 'nps_excellent',
	nps_very_dissatisfied: 'nps_very_dissatisfied',
	nps_dissatisfied: 'nps_dissatisfied',
	nps_neutral: 'nps_neutral',
	nps_satisfied: 'nps_satisfied',
	nps_very_satisfied: 'nps_very_satisfied',
	nps_feedback_placeholder: 'nps_feedback_placeholder',
	nps_followup_title: 'nps_followup_title',
	nps_followup_description: 'nps_followup_description',
	nps_back_to_home: 'nps_back_to_home',
	nps_thankyou_title: 'nps_thankyou_title',
	nps_thankyou_description: 'nps_thankyou_description',
	nps_redirecting_in: 'nps_redirecting_in',
	app_version: 'app_version',
	confirm_logout: 'confirm_logout',
	logout_description: 'logout_description',
	cancel: 'cancel',
	yes: 'yes',
	my_farmer: 'my_farmer',
	request_fail_error_message: 'request_fail_error_message',

	comments: 'comments',
	first_comment: 'first_comment',

	home: 'home',
	my_sauda_bottom_nav: 'my_sauda_bottom_nav',
	sms: 'sms',
	bahi_khata_bottom_nav: 'bahi_khata_bottom_nav',

	submit: 'submit',
	user_name: 'user_name',
	user_name_placeholder: 'user_name_placeholder',
	occupation_name: 'occupation_name',
	business_name: 'business_name',
	shop_name: 'shop_name',
	edit_profile: 'edit_profile',
	edit_photo: 'edit_photo',
	change_photo: 'change_photo',
	add_photo_via: 'add_photo_via',
	open_camera: 'open_camera',
	open_gallery: 'open_gallery',
	not_enter_user_name: 'not_enter_user_name',
	not_enter_shop_name: 'not_enter_shop_name',
	not_both_shop_and_user_name: 'not_both_shop_and_user_name',

	dispatch_details: 'dispatch_details',
	dispatch_weight: 'dispatch_weight',
	enter_dispatch_weight: 'enter_dispatch_weight',
	truck_number: 'truck_number',
	enter_truck_number: 'enter_truck_number',
	sauda_document: 'sauda_document',
	invoice: 'invoice',
	please_add_the_invoice: 'please_add_the_invoice',
	add_weight_slip: 'add_weight_slip',
	add_mandi_tax: 'add_mandi_tax',
	info_message: 'info_message',
	document_added: 'document_added',
	rejected: 'rejected',
	approved: 'approved',
	approve_pending: 'approve_pending',
	no_of_bag: 'no_of_bag',
	enter_no_of_bag: 'enter_no_of_bag',
	error_message_v2: 'error_message_v2',
	cancel_dispatch_confirmation: 'cancel_dispatch_confirmation',
	cancel_dispatch: 'cancel_dispatch',
	continue_dispatch: 'continue_dispatch',
	yes_cancel_dispatch: 'yes_cancel_dispatch',
	back_confirmation_text: 'back_confirmation_text',
	mobile_number_title: 'mobile_number_title',
	mobile_number_placeholder: 'mobile_number_placeholder',
	mandi_tool_tip_heading: 'mandi_tool_tip_heading',
	mandi_tool_tip_message: 'mandi_tool_tip_message',
	truck_error_message: 'truck_error_message',
	updated_today: 'updated_today',
	updated_at: 'updated_at',
	driver_consent_received: 'driver_consent_received',
	driver_consent_pending: 'driver_consent_pending',
	on_track: 'on_track',
	driver_consent_removed: 'driver_consent_removed',
	halted: 'halted',
	potential_delay: 'potential_delay',
	driver_not_reachable: 'driver_not_reachable',
	arrived: 'arrived',
	truck_reached_destination: 'truck_reached_destination',
	trip_cancelled: 'trip_cancelled',
	completed: 'completed',
	cancelled: 'cancelled',
	truck_tracking_available_now: 'truck_tracking_available_now',
	get_payment_within_hours: 'get_payment_within_hours',
	upload_unloading_documents_to_get_payment:
		'upload_unloading_documents_to_get_payment',
	approval_pending: 'approval_pending',
	your_documents_are_uplaoded: 'your_documents_are_uplaoded',
	unloading_documents: 'unloading_documents',
	please_add_the_grn: 'please_add_the_grn',
	unloading_weight_slip: 'unloading_weight_slip',
	please_add_the_unloading_documents: 'please_add_the_unloading_documents',
	buyer_grn: 'buyer_grn',
	please_add_weight_slip: 'please_add_weight_slip',
	wait_till_documents_get_approved: 'wait_till_documents_get_approved',
	unloading_documents_submitted: 'unloading_documents_submitted',
	truck_details: 'truck_details',
	dispatch_documents: 'dispatch_documents',
	truck: 'truck',
	truck_unloaded: 'truck_unloaded',
	truck_dispatched: 'truck_dispatched',
	cancel_unloading: 'cancel_unloading',
	cancel_unloading_heading: 'cancel_unloading_heading',
	cancel_unloading_confirmation: 'cancel_unloading_confirmation',
	cancel_dispatch_heading: 'cancel_dispatch_heading',
	buyer_docs: 'buyer_docs',
	uploaded_on: 'uploaded_on',
	invoice_doc: 'invoice_doc',
	ewaybill_doc: 'ewaybill_doc',
	available_status: 'available_status',
	net_weight_kata_parchi_title: 'net_weight_kata_parchi_title',
	net_weight_kata_parchi_error: 'net_weight_kata_parchi_error',
	net_weight_kata_parchi_placeholder: 'net_weight_kata_parchi_placeholder',
	bardana_weight_title: 'bardana_weight_title',
	bardana_weight_placeholder: 'bardana_weight_placeholder',
	bardana_weight_error_one: 'bardana_weight_error_one',
	bardana_weight_error_two: 'bardana_weight_error_two',

	add_document: 'add_document',
	add_more_files: 'add_more_files',
	address_title: 'address_title',
	back_confirmation: 'back_confirmation',
	bill_to: 'bill_to',
	bill_to_title: 'bill_to_title',
	cancel_upload: 'cancel_upload',
	continue_uploading: 'continue_uploading',
	document_upload_confirmation_text: 'document_upload_confirmation_text',
	done: 'done',
	file_format_not_acceptable: 'file_format_not_acceptable',
	file_limit_five: 'file_limit_five',
	file_limit_one: 'file_limit_one',
	file_list_alert: 'file_list_alert',
	file_size_exceeded: 'file_size_exceeded',
	gst_title: 'gst_title',
	invoice_docs: 'invoice_docs',
	list_of_files: 'list_of_files',
	mandi_tax: 'mandi_tax',
	max_files_to_upload_per_document: 'max_files_to_upload_per_document',
	re_upload: 're_upload',
	re_upload_rejected_documents: 're_upload_rejected_documents',
	supported_formats_text: 'supported_formats_text',
	unloading_file_list_alert: 'unloading_file_list_alert',
	unloading_max_file_upload: 'unloading_max_file_upload',
	weight_slip: 'weight_slip',

	second: 'second',
	minutes_ago: 'minutes_ago',
	hour_ago: 'hour_ago',
	minutes: 'minutes',
	hour: 'hour',
	hours: 'hours',
	minute: 'minute',
	ago: 'ago',
	days: 'days',
	last_week: 'last_week',
	yesterday: 'yesterday',
	weeks: 'weeks',
	last_month: 'last_month',
	months: 'months',
	last_year: 'last_year',
	years: 'years',

	error_state_heading: 'error_state_heading',
	error_state_sub_heading: 'error_state_sub_heading',
	error_state_primary_button: 'error_state_primary_button',
	error_state_secondary_button: 'error_state_secondary_button',

	heading_payment_details: 'heading_payment_details',
	sub_heading_payment_details: 'sub_heading_payment_details',
	truck_no: 'truck_no',
	amount_paid: 'amount_paid',
	utr: 'utr',
	disclaimer: 'disclaimer',
	trust_partner: 'trust_partner',
	button_text: 'button_text',
	back_to_home: 'back_to_home',

	trip_created: 'trip_created',
	take_driver_consent_message: 'take_driver_consent_message',
	consent_received_message: 'consent_received_message',
	consent_reminder_sent_message: 'consent_reminder_sent_message',
	consent_reminder_button_active: 'consent_reminder_button_active',
	consent_reminder_button_disabled: 'consent_reminder_button_disabled',
	how_to_get_consent_from_driver: 'how_to_get_consent_from_driver',
	follow_the_steps_given_below_or_watch_video:
		'follow_the_steps_given_below_or_watch_video',
	watch_how_to_take_consent: 'watch_how_to_take_consent',
	take_consent_step_one_title: 'take_consent_step_one_title',
	take_consent_step_one_description: 'take_consent_step_one_description',
	take_consent_step_two_title: 'take_consent_step_two_title',
	take_consent_step_two_description: 'take_consent_step_two_description',
	if_driver_has_no_jio_card: 'if_driver_has_no_jio_card',
	give_missed_call_to: 'give_missed_call_to',
	if_no_other_sim: 'if_no_other_sim',
	once_driver_complete_these_steps: 'once_driver_complete_these_steps',
	deliver_to: 'deliver_to',
	truck_route_detail: 'truck_route_detail',
	dispatched_from: 'dispatched_from',
	expected_delivery: 'expected_delivery',
	estimated_distance: 'estimated_distance',
	kms: 'kms',
	consent_message: 'consent_message',
	missed_call_no_other_sim: 'missed_call_no_other_sim',
	destination_at: 'destination_at',
	truck_driver_details: 'truck_driver_details',

	no_buyer_found: 'no_buyer_found',

	heading_bahi_khata: 'heading_bahi_khata',
	guide_modal_description: 'guide_modal_description',
	guide_modal_button: 'guide_modal_button',
	header_secure_msg: 'header_secure_msg',
	you_will_give: 'you_will_give',
	you_will_get: 'you_will_get',
	record_new_transaction: 'record_new_transaction',
	empty_state_msg: 'empty_state_msg',
	search_khata: 'search_khata',
	all_khata: 'all_khata',
	filter_lable: 'filter_lable',
	sort_lable: 'sort_lable',
	recent_first: 'recent_first',
	alphabetically_order: 'alphabetically_order',
	all_settled: 'all_settled',
	no_balance: 'no_balance',
	user_khata_created_date: 'user_khata_created_date',
	khata_deleted: 'khata_deleted',

	search_khata_placeholder: 'search_khata_placeholder',
	search_khata_lable: 'search_khata_lable',
	no_khata_found: 'no_khata_found',

	title: 'title',
	add_khata_button: 'add_khata_button',
	saved_khata_heading: 'saved_khata_heading',
	recent_khata_heading: 'recent_khata_heading',
	search_placeholder: 'search_placeholder',
	enable_contact_permission: 'enable_contact_permission',
	enable_contact_permission_info: 'enable_contact_permission_info',
	download_app_info: 'download_app_info',
	add_search_new_khata: 'add_search_new_khata',

	title_new_transaction_with: 'title_new_transaction_with',
	input_name_heading: 'input_name_heading',
	input_name_heading_placeholder: 'input_name_heading_placeholder',
	input_contact_heading: 'input_contact_heading',
	input_contact_heading_placeholder: 'input_contact_heading_placeholder',
	continue_button: 'continue_button',

	giving_credit: 'giving_credit',
	receiving_credit: 'receiving_credit',
	enter_amount_lent: 'enter_amount_lent',
	enter_amount_received: 'enter_amount_received',
	note_placeholder: 'note_placeholder',
	save_button: 'save_button',
	attach_one_picture: 'attach_one_picture',
	replace_old_image_button: 'replace_old_image_button',
	no_button: 'no_button',
	delete_image_button: 'delete_image_button',
	send_sms_to: 'send_sms_to',
	remind_credit_button: 'remind_credit_button',
	send_later_button: 'send_later_button',
	template_str: 'template_str',
	camera_permission_heading: 'camera_permission_heading',
	camera_permission_desc: 'camera_permission_desc',
	go_to_settings: 'go_to_settings',

	title_new_transaction: 'title_new_transaction',
	setting_permission_info: 'setting_permission_info',
	setting_permission_steps: 'setting_permission_steps',
	setting_permission_button: 'setting_permission_button',
	add_manually_button: 'add_manually_button',
	record_transaction_title: 'record_transaction_title',

	title_bahi_khata_acknowledgement: 'title_bahi_khata_acknowledgement',
	payment_notice_line: 'payment_notice_line',
	protect_button: 'protect_button',
	received_notice_line: 'received_notice_line',

	date_tenure: 'date_tenure',
	today: 'today',
	no_transaction: 'no_transaction',
	recieve_money: 'recieve_money',
	give_credit: 'give_credit',
	give_credit_to: 'give_credit_to',
	you_will_recieve: 'you_will_recieve',
	credit_given: 'credit_given',
	delete_transaction: 'delete_transaction',
	confirm_delete_transaction: 'confirm_delete_transaction',
	yes_delete: 'yes_delete',
	no: 'no',
	remind_khata_title: 'remind_khata_title',
	remind_khata_message: 'remind_khata_message',
	remind_khata_total_message: 'remind_khata_total_message',
	remind_credit: 'remind_credit',
	send_later: 'send_later',
	edit_proifle: 'edit_proifle',
	delete_khata: 'delete_khata',
	delete_khata_title: 'delete_khata_title',
	delete_khata_message: 'delete_khata_message',
	name: 'name',
	contact_number: 'contact_number',
	update_details: 'update_details',
	profile_update_message: 'profile_update_message',
	edit_amount: 'edit_amount',
	edit_note: 'edit_note',
	send_sms_reminder: 'send_sms_reminder',
	delete_note: 'delete_note',
	delete_message: 'delete_message',
	save: 'save',
	note_update_message: 'note_update_message',
	add_note: 'add_note',
	note_placeholder_v2: 'note_placeholder_v2',
	payment_recieved: 'payment_recieved',
	image: 'image',
	reminder_sent: 'reminder_sent',
	amount_update: 'amount_update',
	delete_image_modal_button: 'delete_image_modal_button',
	replace_image_modal_title: 'replace_image_modal_title',
	replace_image_modal_button: 'replace_image_modal_button',
	something_went_wrong: 'something_went_wrong',

	skip: 'skip',
	got_it: 'got_it',
	next: 'next',

	heading_user_interest: 'heading_user_interest',
	sub_heading_user_interest: 'sub_heading_user_interest',

	distributor_heading: 'distributor_heading',
	change_location_text_distributor: 'change_location_text_distributor',
	no_distributor_found: 'no_distributor_found',
	category: 'category',
	product_type: 'product_type',
	distributor_found: 'distributor_found',
	seeds: 'seeds',
	pesticides: 'pesticides',
	fertilisers: 'fertilisers',
	select_category: 'select_category',
	select_product_type: 'select_product_type',
	clear_all: 'clear_all',
	search_by_fertilizer_name: 'search_by_fertilizer_name',
	no_fertiliser_type_found: 'no_fertiliser_type_found',

	farmart_ai_nav: 'farmart_ai_nav',

	my_updates: 'my_updates',
	rake_primary_header_enable_location: 'rake_primary_header_enable_location',
	rake_primary_header_nearby_location: 'rake_primary_header_nearby_location',
	rake_primary_header_arrived_at_location:
		'rake_primary_header_arrived_at_location',
	rake_primary_header_will_arrive: 'rake_primary_header_will_arrive',
	rake_primary_button_enable_location: 'rake_primary_button_enable_location',
	rake_primary_button_nearby_location: 'rake_primary_button_nearby_location',
	rake_primary_button_arrived_at_location:
		'rake_primary_button_arrived_at_location',
	rake_primary_button_will_arrive: 'rake_primary_button_will_arrive',
	rake_card_give_location: 'rake_card_give_location',
	trusted_by_people: 'trusted_by_people',
	trusted_buyers_title: 'trusted_buyers_title',
	trusted_buyers_description: 'trusted_buyers_description',
	payment_guarantee_title: 'payment_guarantee_title',
	payment_guarantee_description: 'payment_guarantee_description',
	secure_trading_title: 'secure_trading_title',
	secure_trading_description: 'secure_trading_description',
	bahi_khata_primary_header_pending_amt: 'bahi_khata_primary_header_pending_amt',
	bahi_khata_primary_header_summary: 'bahi_khata_primary_header_summary',
	bahi_khata_primary_button_pending_amt: 'bahi_khata_primary_button_pending_amt',
	bahi_khata_primary_button_start_recording:
		'bahi_khata_primary_button_start_recording',
	bahi_khata_primary_button_summary: 'bahi_khata_primary_button_summary',
	bahi_khata_primary_button_remind: 'bahi_khata_primary_button_remind',
	you_will_receive: 'you_will_receive',
	need_help: 'need_help',
	ask_us_on_whatsapp: 'ask_us_on_whatsapp',
	get_instant_support_from_our_team: 'get_instant_support_from_our_team',
	open_faq_heading: 'open_faq_heading',
	open_faq_sub_heading: 'open_faq_sub_heading',
	top_active_buyers: 'top_active_buyers',
	see_details: 'see_details',
	view_more_prices: 'view_more_prices',
	request_now: 'request_now',
	expired: 'expired',
	top_active_buyers_description: 'top_active_buyers_description',
	buyer_prices: 'buyer_prices',
	do_not_miss_live_prices_tomorrow_at: 'do_not_miss_live_prices_tomorrow_at',
	do_not_miss_live_prices_today_at: 'do_not_miss_live_prices_today_at',
	action_pending: 'action_pending',
	in_sauda: 'in_sauda',
	view: 'view',
	live: 'live',
	new: 'new',
	arriving: 'arriving',
	sms_credit_exhausted_title: 'sms_credit_exhausted_title',
	sms_credit_exhausted_message: 'sms_credit_exhausted_message',
	sms_credit_exhausted_button: 'sms_credit_exhausted_button',
	sms_credit_expiring_soon_title: 'sms_credit_expiring_soon_title',
	sms_credit_expiring_soon_message: 'sms_credit_expiring_soon_message',
	sms_credit_expiring_soon_button: 'sms_credit_expiring_soon_button',
	sms_festival_reminder_title: 'sms_festival_reminder_title',
	sms_festival_reminder_message: 'sms_festival_reminder_message',
	sms_festival_reminder_button: 'sms_festival_reminder_button',
	sms_festival_reminder_no_credit_title: 'sms_festival_reminder_no_credit_title',
	sms_festival_reminder_no_credit_message:
		'sms_festival_reminder_no_credit_message',
	sms_festival_reminder_no_credit_button:
		'sms_festival_reminder_no_credit_button',
	sms_frequently_used_title: 'sms_frequently_used_title',
	sms_frequently_used_message: 'sms_frequently_used_message',
	sms_frequently_used_button: 'sms_frequently_used_button',
	rake_arrive_near_district: 'rake_arrive_near_district',
	rake_arrive_near_district_button: 'rake_arrive_near_district_button',
	pending_amount_to_recieved: 'pending_amount_to_recieved',
	swipe_left: 'swipe_left',
	ai_placeholder_1: 'ai_placeholder_1',
	ai_placeholder_2: 'ai_placeholder_2',
	ai_placeholder_3: 'ai_placeholder_3',
	ai_placeholder_4: 'ai_placeholder_4',
	no_whatsapp_account_found: 'no_whatsapp_account_found',
	whatsapp_message_text: 'whatsapp_message_text',

	po_payment_detail: 'po_payment_detail',
	po_created_on_ledger: 'po_created_on_ledger',
	invoice_number: 'invoice_number',
	rupees: 'rupees',
	order_value: 'order_value',
	deduction: 'deduction',
	tds_ledger: 'tds_ledger',
	total_amount_payable_ledger: 'total_amount_payable_ledger',
	view_transaction: 'view_transaction',
	download_invoice: 'download_invoice',
	gst_details_ledger: 'gst_details_ledger',
	paid: 'paid',
	pending: 'pending',
	utr_number_ledger: 'utr_number_ledger',
	gst_transactions: 'gst_transactions',
	transactions: 'transactions',

	select_date_range: 'select_date_range',
	current_week: 'current_week',
	current_month: 'current_month',
	last_3_months: 'last_3_months',
	current_financial_year: 'current_financial_year',
	last_financial_year: 'last_financial_year',
	custom_date_ledger: 'custom_date_ledger',
	back: 'back',
	refresh: 'refresh',
	load_more: 'load_more',
	no_data: 'no_data',
	loading: 'loading',
	error: 'error',
	transaction_list_label: 'transaction_list_label',
	download_invoice_label: 'download_invoice_label',
	payable_label_ledger: 'payable_label_ledger',
	order_placed_via: 'order_placed_via',
	total_payable: 'total_payable',
	info_header: 'info_header',
	info_description: 'info_description',
	info_details_1: 'info_details_1',
	info_details_2: 'info_details_2',
	info_details_3: 'info_details_3',
	info_sub_detail_1: 'info_sub_detail_1',
	info_sub_detail_2: 'info_sub_detail_2',
	info_sub_detail_3: 'info_sub_detail_3',
	total_payble_info_header: 'total_payble_info_header',
	total_payble_info_descreption: 'total_payble_info_descreption',
	paid_info_header: 'paid_info_header',
	paid_info_description: 'paid_info_description',
	pending_info_header: 'pending_info_header',
	pending_info_description: 'pending_info_description',
	heading: 'heading',
	order_count: 'order_count',
	close_ledger: 'close_ledger',
	no_transactions_found: 'no_transactions_found',
	start_sauda: 'start_sauda',
	no_purchase_during_periods: 'no_purchase_during_periods',
	back_to_current_fy: 'back_to_current_fy',
	fy: 'fy',

	what_is_ledger: 'what_is_ledger',
	what_is_ledger_description: 'what_is_ledger_description',
	what_is_ledger_disclaimer: 'what_is_ledger_disclaimer',
	show_me_my_ledger: 'show_me_my_ledger',
	my_ledger: 'my_ledger',
	ai_search_tour_guide_message: 'ai_search_tour_guide_message',
	bahi_khata_tour_guide_message: 'bahi_khata_tour_guide_message',
	shop_promotion_tour_guide_message: 'shop_promotion_tour_guide_message',
	trade_tour_guide_message: 'trade_tour_guide_message',
	my_sauda_tour_guide_message: 'my_sauda_tour_guide_message',
	community_tour_guide_message: 'community_tour_guide_message',
	quiz_tour_guide_message: 'quiz_tour_guide_message',
	rake_tour_guide_message: 'rake_tour_guide_message',
	distributor_tour_guide_message: 'distributor_tour_guide_message',

	how_can_i_help_you: 'how_can_i_help_you',
	bullet_one: 'bullet_one',
	bullet_two: 'bullet_two',
	bullet_three: 'bullet_three',
	bullet_four: 'bullet_four',
	ask_me_anything: 'ask_me_anything',
	new_chat: 'new_chat',
	no_chat_found: 'no_chat_found',
	your_agri_business_partner: 'your_agri_business_partner',
	beta_version: 'beta_version',
	okay_ai: 'okay_ai',
	copy: 'copy',
	copied: 'copied',
	searching_web: 'searching_web',
	farmart_ai_beta_version: 'farmart_ai_beta_version',
	my_community: 'my_community',
	next_question: 'next_question',
	exit_prompt_title: 'exit_prompt_title',
	exit_prompt_message: 'exit_prompt_message',
	exit_confirm: 'exit_confirm',
	continue_quiz: 'continue_quiz',
	thank_you: 'thank_you',
	result_info: 'result_info',
	result_countdown: 'result_countdown',
	question_count: 'question_count',
	label_days: 'label_days',
	label_hours: 'label_hours',
	label_minutes: 'label_minutes',
	check_score: 'check_score',
	view_results: 'view_results',
	congrats: 'congrats',
	quiz_winner: 'quiz_winner',
	quiz_score: 'quiz_score',
	view_answers: 'view_answers',
	next_quiz_starts_in: 'next_quiz_starts_in',
	check_winners: 'check_winners',
	answers: 'answers',
	score: 'score',
	your_answer: 'your_answer',
	winners_list: 'winners_list',
	quiz_title: 'quiz_title',
	total_winners: 'total_winners',
	no_winners: 'no_winners',
	you_label: 'you_label',
	better_luck: 'better_luck',
	back_home: 'back_home',
	choose_an_option: 'choose_an_option',
	cta_trade: 'cta_trade',
	cta_mysauda: 'cta_mysauda',
	cta_community: 'cta_community',
	cta_rake: 'cta_rake',
	cta_bahi_khata: 'cta_bahi_khata',
	cta_promotion: 'cta_promotion',
	wapp_strip_one: 'wapp_strip_one',
	wapp_strip_two: 'wapp_strip_two',
	wapp_strip_three: 'wapp_strip_three',
	wapp_strip_four: 'wapp_strip_four',
	wapp_strip_five: 'wapp_strip_five',
	you_missed_quiz: 'you_missed_quiz',
	next_quiz_soon: 'next_quiz_soon',

	update_tile_heading: 'update_tile_heading',
	update_tile_sub_heading: 'update_tile_sub_heading',
	update_version_current: 'update_version_current',
	update_version_new: 'update_version_new',
	update_now: 'update_now',
	update_later: 'update_later',

	ai_quick_action_tour_guide_message: 'ai_quick_action_tour_guide_message',
	ai_text_area_tour_guide_message: 'ai_text_area_tour_guide_message',
	ai_speak_tour_guide_message: 'ai_speak_tour_guide_message',
	ai_upload_image_tour_guide_message: 'ai_upload_image_tour_guide_message',

	switch_profile: 'switch_profile',
	consent_rejected: 'consent_rejected',
	consent_rejected_description: 'consent_rejected_description',
	consent_rejected_note: 'consent_rejected_note',
	consent_redirection: 'consent_redirection',
	consent_accepted: 'consent_accepted',
	consent_accepted_description: 'consent_accepted_description',
	supplier_kyc_approve_button: 'supplier_kyc_approve_button',
	supplier_kyc_reject_button: 'supplier_kyc_reject_button',
	supplier_kyc_approve_description: 'supplier_kyc_approve_description',
	business_name_from_kyc: 'business_name_from_kyc',
	tds_terms_and_conditions: 'tds_terms_and_conditions',
	tds_terms_condition_1: 'tds_terms_condition_1',
	tds_terms_condition_2: 'tds_terms_condition_2',
	tds_terms_confirm: 'tds_terms_confirm',
	general_consent_text: 'general_consent_text',
	general_consent_confirm: 'general_consent_confirm',
	msme_declaration_title: 'msme_declaration_title',
	msme_declaration_text: 'msme_declaration_text',
	msme_declaration_agree: 'msme_declaration_agree',
	msme_declaration_point1: 'msme_declaration_point1',
	msme_declaration_point2: 'msme_declaration_point2',
	msme_declaration_point3: 'msme_declaration_point3',
	rejectConsentHeading: 'rejectConsentHeading',
	rejectConsentDescription: 'rejectConsentDescription',
	rejectConsentGoBack: 'rejectConsentGoBack',
	rejectConsentConfirm: 'rejectConsentConfirm',
	poc_details_info: 'poc_details_info',
	consent_pending: 'consent_pending',
	consent_pending_description: 'consent_pending_description',
	debit_notes: 'debit_notes',
	view_dn: 'view_dn',
	debit_note: 'debit_note',
	farmart_ai_ask_abt_post: 'farmart_ai_ask_abt_post',
	farmart_ai_ask_more: 'farmart_ai_ask_more',

	poll_of_the_day: 'poll_of_the_day',
	polls_closes_in_2hrs: 'polls_closes_in_2hrs',
	'85_votes_so_far': '85_votes_so_far',
	result_will_be_declared_in_1hr: 'result_will_be_declared_in_1hr',
	absolutely_right_youre_a_total_expert: 'absolutely_right_youre_a_total_expert',
	total_100_votes: 'total_100_votes',
	wrong_answer_try_again_tomorrow: 'wrong_answer_try_again_tomorrow',
	you_missed_the_poll_next_poll_starts_soon:
		'you_missed_the_poll_next_poll_starts_soon',
	poll_closed: 'poll_closed',
	no_votes_yet: 'no_votes_yet',
	correct_answer: 'correct_answer',
	you_missed_this_poll_next_poll_starts_soon:
		'you_missed_this_poll_next_poll_starts_soon',
	like: 'like',

	last_updated: 'last_updated',
	search_posts: 'search_posts',
	ai_tool_tip_first: 'ai_tool_tip_first',
	ai_tool_tip_second: 'ai_tool_tip_second',
	shares: 'shares',
	no_post_found: 'no_post_found',
	comment_as: 'comment_as',
	no_comments: 'no_comments',
	view_community: 'view_community',
	replies_community: 'replies_community',
	read_more: 'read_more',
	view_more: 'view_more',
	hide_replies: 'hide_replies',
	reply: 'reply',
	reply_comment: 'reply_comment',
	community_comment_submit_failed: 'community_comment_submit_failed',
	community_comment_restricted_contact_support:
		'community_comment_restricted_contact_support',
	take_consent_have_other_issues: 'take_consent_have_other_issues',
	take_consent_contact_us: 'take_consent_contact_us',
	take_consent_need_help: 'take_consent_need_help',
	take_consent_cancel_trip: 'take_consent_cancel_trip',
	take_consent_deliver_to: 'take_consent_deliver_to',
	take_consent_dispatched_from: 'take_consent_dispatched_from',
	take_consent_destination_at: 'take_consent_destination_at',
	take_consent_expected_delivery: 'take_consent_expected_delivery',
	take_consent_estimated_distance: 'take_consent_estimated_distance',
	take_consent_kms: 'take_consent_kms',
	take_consent_trip_cancelled: 'take_consent_trip_cancelled',
	take_consent_truck_driver_details: 'take_consent_truck_driver_details',
	take_consent_trip_cancelled_within_24_hrs:
		'take_consent_trip_cancelled_within_24_hrs',
	consent_pending_page_consent_message: 'consent_pending_page_consent_message',
	edit_driver_detail_confirmation_title: 'edit_driver_detail_confirmation_title',
	edit_driver_detail_confirmation_description:
		'edit_driver_detail_confirmation_description',
	proceed_to_exit: 'proceed_to_exit',
	cancel_edit: 'cancel_edit',
	edit_driver_detail_dialog_title: 'edit_driver_detail_dialog_title',
	edit_driver_detail_note: 'edit_driver_detail_note',
	driver_number: 'driver_number',
	driver_number_note: 'driver_number_note',
	driver_name: 'driver_name',
	take_consent_save: 'take_consent_save',
	cancel_trip: 'cancel_trip',
	cancel_trip_note: 'cancel_trip_note',
	take_consent_yes: 'take_consent_yes',
	take_consent_no: 'take_consent_no',
	take_consent_help: 'take_consent_help',
	take_consent_faq_title: 'take_consent_faq_title',
	take_consent_video_one_title: 'take_consent_video_one_title',
	take_consent_video_two_title: 'take_consent_video_two_title',
	// KYC Details
	kyc_details: 'kyc_details',
	self_kyc_title: 'self_kyc_title',
	self_kyc_select_type_title: 'self_kyc_select_type_title',
	self_kyc_select_type_subtitle: 'self_kyc_select_type_subtitle',
	self_kyc_landing_title: 'self_kyc_landing_title',
	self_kyc_landing_subtitle: 'self_kyc_landing_subtitle',
	self_kyc_profile_card_subtitle: 'self_kyc_profile_card_subtitle',
	self_kyc_landing_verify_title: 'self_kyc_landing_verify_title',
	self_kyc_landing_verify_message: 'self_kyc_landing_verify_message',
	self_kyc_docs_ready_title: 'self_kyc_docs_ready_title',
	self_kyc_doc_pan_aadhaar: 'self_kyc_doc_pan_aadhaar',
	self_kyc_doc_pan_aadhaar_hint: 'self_kyc_doc_pan_aadhaar_hint',
	self_kyc_doc_gst: 'self_kyc_doc_gst',
	self_kyc_doc_gst_hint: 'self_kyc_doc_gst_hint',
	self_kyc_doc_bank: 'self_kyc_doc_bank',
	self_kyc_doc_bank_hint: 'self_kyc_doc_bank_hint',
	self_kyc_doc_udyam: 'self_kyc_doc_udyam',
	self_kyc_doc_udyam_hint: 'self_kyc_doc_udyam_hint',
	self_kyc_doc_mandi: 'self_kyc_doc_mandi',
	self_kyc_doc_mandi_hint: 'self_kyc_doc_mandi_hint',
	self_kyc_doc_optional: 'self_kyc_doc_optional',
	mandi_request_submitted_successfully: 'mandi_request_submitted_successfully',
	confirm_mandi_license: 'confirm_mandi_license',
	change_mandi_license: 'change_mandi_license',
	self_kyc_individual: 'self_kyc_individual',
	self_kyc_individual_hint: 'self_kyc_individual_hint',
	self_kyc_business: 'self_kyc_business',
	self_kyc_business_hint: 'self_kyc_business_hint',
	self_kyc_upfront_consent_title: 'self_kyc_upfront_consent_title',
	self_kyc_upfront_consent_hint: 'self_kyc_upfront_consent_hint',
	self_kyc_upfront_consent_text: 'self_kyc_upfront_consent_text',
	self_kyc_pan_unavailable_aadhaar: 'self_kyc_pan_unavailable_aadhaar',
	self_kyc_no_pan_prompt: 'self_kyc_no_pan_prompt',
	self_kyc_use_aadhaar: 'self_kyc_use_aadhaar',
	self_kyc_use_pan: 'self_kyc_use_pan',
	self_kyc_change_aadhaar: 'self_kyc_change_aadhaar',
	self_kyc_resend_otp: 'self_kyc_resend_otp',
	self_kyc_otp_not_received: 'self_kyc_otp_not_received',
	self_kyc_status_valid: 'self_kyc_status_valid',
	self_kyc_status_invalid: 'self_kyc_status_invalid',
	self_kyc_gst_empty_title: 'self_kyc_gst_empty_title',
	self_kyc_gst_all_inactive_title: 'self_kyc_gst_all_inactive_title',
	self_kyc_gst_all_unselectable_title: 'self_kyc_gst_all_unselectable_title',
	self_kyc_gst_all_unselectable_message: 'self_kyc_gst_all_unselectable_message',
	self_kyc_gst_fetch_error_title: 'self_kyc_gst_fetch_error_title',
	self_kyc_gst_fetch_error_message: 'self_kyc_gst_fetch_error_message',
	self_kyc_gst_edge_message: 'self_kyc_gst_edge_message',
	self_kyc_gst_already_exists_hint: 'self_kyc_gst_already_exists_hint',
	self_kyc_gst_inactive_hint: 'self_kyc_gst_inactive_hint',
	self_kyc_gst_duplicate_state_hint: 'self_kyc_gst_duplicate_state_hint',
	self_kyc_error_gst_required: 'self_kyc_error_gst_required',
	self_kyc_error_gst_address_required: 'self_kyc_error_gst_address_required',
	self_kyc_error_gst_already_exists: 'self_kyc_error_gst_already_exists',
	self_kyc_error_gst_already_exists_edit:
		'self_kyc_error_gst_already_exists_edit',
	self_kyc_error_gst_edit_pending: 'self_kyc_error_gst_edit_pending',
	self_kyc_error_gst_address_empty: 'self_kyc_error_gst_address_empty',
	self_kyc_skip_gst: 'self_kyc_skip_gst',
	self_kyc_skip_msme: 'self_kyc_skip_msme',
	self_kyc_change_pan: 'self_kyc_change_pan',
	self_kyc_exit_draft_title: 'self_kyc_exit_draft_title',
	self_kyc_exit_draft_message: 'self_kyc_exit_draft_message',
	self_kyc_exit_stay: 'self_kyc_exit_stay',
	self_kyc_exit_leave: 'self_kyc_exit_leave',
	self_kyc_bank_helper: 'self_kyc_bank_helper',
	self_kyc_bank_issue_label: 'self_kyc_bank_issue_label',
	self_kyc_error_bank_invalid_ifsc: 'self_kyc_error_bank_invalid_ifsc',
	self_kyc_error_bank_invalid_account: 'self_kyc_error_bank_invalid_account',
	self_kyc_error_bank_holder_mismatch: 'self_kyc_error_bank_holder_mismatch',
	self_kyc_error_bank_duplicate: 'self_kyc_error_bank_duplicate',
	self_kyc_error_bank_invalid_details: 'self_kyc_error_bank_invalid_details',
	self_kyc_error_bank_nre: 'self_kyc_error_bank_nre',
	self_kyc_error_bank_blocked: 'self_kyc_error_bank_blocked',
	self_kyc_error_bank_payment_in_progress:
		'self_kyc_error_bank_payment_in_progress',
	self_kyc_error_bank_no_change: 'self_kyc_error_bank_no_change',
	self_kyc_error_bank_account_format: 'self_kyc_error_bank_account_format',
	self_kyc_msme_issue_label: 'self_kyc_msme_issue_label',
	self_kyc_error_msme_invalid: 'self_kyc_error_msme_invalid',
	self_kyc_error_msme_inactive: 'self_kyc_error_msme_inactive',
	self_kyc_error_msme_inactive_add_later:
		'self_kyc_error_msme_inactive_add_later',
	self_kyc_error_msme_cancelled: 'self_kyc_error_msme_cancelled',
	self_kyc_error_msme_cancelled_add_later:
		'self_kyc_error_msme_cancelled_add_later',
	self_kyc_error_msme_duplicate: 'self_kyc_error_msme_duplicate',
	self_kyc_error_msme_gst_select: 'self_kyc_error_msme_gst_select',
	self_kyc_error_msme_gst_overlap: 'self_kyc_error_msme_gst_overlap',
	self_kyc_error_msme_gst_overlap_add_later:
		'self_kyc_error_msme_gst_overlap_add_later',
	self_kyc_error_proprietor_document_required:
		'self_kyc_error_proprietor_document_required',
	self_kyc_error_proprietor_document_upload:
		'self_kyc_error_proprietor_document_upload',
	self_kyc_skip_mandi: 'self_kyc_skip_mandi',
	self_kyc_mandi_number_label: 'self_kyc_mandi_number_label',
	self_kyc_mandi_verified_hint: 'self_kyc_mandi_verified_hint',
	self_kyc_mandi_optional_hint: 'self_kyc_mandi_optional_hint',
	self_kyc_mandi_document_label: 'self_kyc_mandi_document_label',
	self_kyc_mandi_document_hint: 'self_kyc_mandi_document_hint',
	self_kyc_error_mandi_required: 'self_kyc_error_mandi_required',
	self_kyc_error_mandi_not_found: 'self_kyc_error_mandi_not_found',
	self_kyc_error_mandi_document_required:
		'self_kyc_error_mandi_document_required',
	self_kyc_error_mandi_document_upload: 'self_kyc_error_mandi_document_upload',
	self_kyc_error_mandi_save_failed: 'self_kyc_error_mandi_save_failed',
	self_kyc_error_mandi_duplicate: 'self_kyc_error_mandi_duplicate',
	self_kyc_mandi_expired: 'self_kyc_mandi_expired',
	self_kyc_mandi_add_another: 'self_kyc_mandi_add_another',
	self_kyc_error_mandi_not_yours: 'self_kyc_error_mandi_not_yours',
	self_kyc_error_mandi_skip_failed: 'self_kyc_error_mandi_skip_failed',
	self_kyc_individual_pan_warning: 'self_kyc_individual_pan_warning',
	self_kyc_business_pan_warning: 'self_kyc_business_pan_warning',
	self_kyc_verification_label: 'self_kyc_verification_label',
	self_kyc_error_failed_title: 'self_kyc_error_failed_title',
	self_kyc_error_limit_title: 'self_kyc_error_limit_title',
	self_kyc_error_limit_message: 'self_kyc_error_limit_message',
	self_kyc_error_support_title: 'self_kyc_error_support_title',
	self_kyc_error_already_exists_title: 'self_kyc_error_already_exists_title',
	self_kyc_retry: 'self_kyc_retry',
	self_kyc_okay_got_it: 'self_kyc_okay_got_it',
	self_kyc_exit_kyc: 'self_kyc_exit_kyc',
	self_kyc_add_address: 'self_kyc_add_address',
	self_kyc_close: 'self_kyc_close',
	self_kyc_call_support: 'self_kyc_call_support',
	self_kyc_verification_in_progress: 'self_kyc_verification_in_progress',
	self_kyc_aadhaar_otp_hint: 'self_kyc_aadhaar_otp_hint',
	self_kyc_aadhaar_otp_hint_masked: 'self_kyc_aadhaar_otp_hint_masked',
	self_kyc_gst_select_hint: 'self_kyc_gst_select_hint',
	self_kyc_gst_address_hint: 'self_kyc_gst_address_hint',
	self_kyc_msme_optional_hint: 'self_kyc_msme_optional_hint',
	self_kyc_udyam_help_title: 'self_kyc_udyam_help_title',
	self_kyc_udyam_help_subtitle: 'self_kyc_udyam_help_subtitle',
	self_kyc_manual_address_hint: 'self_kyc_manual_address_hint',
	self_kyc_manual_address_note: 'self_kyc_manual_address_note',
	self_kyc_error_address_proof_format: 'self_kyc_error_address_proof_format',
	self_kyc_error_file_too_large: 'self_kyc_error_file_too_large',
	self_kyc_error_address_gst_exists: 'self_kyc_error_address_gst_exists',
	self_kyc_poc_name: 'self_kyc_poc_name',
	self_kyc_poc_mobile: 'self_kyc_poc_mobile',
	self_kyc_poc_email: 'self_kyc_poc_email',
	self_kyc_otp_label: 'self_kyc_otp_label',
	self_kyc_aadhaar_placeholder: 'self_kyc_aadhaar_placeholder',
	self_kyc_account_placeholder: 'self_kyc_account_placeholder',
	self_kyc_ifsc_placeholder: 'self_kyc_ifsc_placeholder',
	self_kyc_pincode_placeholder: 'self_kyc_pincode_placeholder',
	self_kyc_street_placeholder: 'self_kyc_street_placeholder',
	self_kyc_poc_name_placeholder: 'self_kyc_poc_name_placeholder',
	self_kyc_poc_mobile_placeholder: 'self_kyc_poc_mobile_placeholder',
	self_kyc_poc_email_placeholder: 'self_kyc_poc_email_placeholder',
	self_kyc_final_consent_text: 'self_kyc_final_consent_text',
	self_kyc_submitted_title: 'self_kyc_submitted_title',
	self_kyc_submitted_message: 'self_kyc_submitted_message',
	self_kyc_completed_auto_title: 'self_kyc_completed_auto_title',
	self_kyc_completed_auto_message: 'self_kyc_completed_auto_message',
	self_kyc_completed_manual_title: 'self_kyc_completed_manual_title',
	self_kyc_completed_manual_message: 'self_kyc_completed_manual_message',
	self_kyc_verification_wait: 'self_kyc_verification_wait',
	self_kyc_change_details: 'self_kyc_change_details',
	self_kyc_start_cta: 'self_kyc_start_cta',
	self_kyc_continue_cta: 'self_kyc_continue_cta',
	self_kyc_start_message: 'self_kyc_start_message',
	self_kyc_nudge_title: 'self_kyc_nudge_title',
	self_kyc_nudge_message: 'self_kyc_nudge_message',
	self_kyc_nudge_cta: 'self_kyc_nudge_cta',
	self_kyc_nudge_dismiss: 'self_kyc_nudge_dismiss',
	self_kyc_error_pan: 'self_kyc_error_pan',
	self_kyc_error_pan_for_business: 'self_kyc_error_pan_for_business',
	self_kyc_error_pan_for_individual: 'self_kyc_error_pan_for_individual',
	self_kyc_error_aadhaar: 'self_kyc_error_aadhaar',
	self_kyc_error_otp: 'self_kyc_error_otp',
	self_kyc_error_account: 'self_kyc_error_account',
	self_kyc_error_ifsc: 'self_kyc_error_ifsc',
	self_kyc_error_pincode: 'self_kyc_error_pincode',
	self_kyc_error_pincode_not_serviceable:
		'self_kyc_error_pincode_not_serviceable',
	self_kyc_error_street: 'self_kyc_error_street',
	self_kyc_error_generic: 'self_kyc_error_generic',
	self_kyc_error_session_restart: 'self_kyc_error_session_restart',
	self_kyc_error_poc_save_failed: 'self_kyc_error_poc_save_failed',
	self_kyc_error_address_save_failed: 'self_kyc_error_address_save_failed',
	self_kyc_error_msme_skip_failed: 'self_kyc_error_msme_skip_failed',
	self_kyc_error_verification_failed: 'self_kyc_error_verification_failed',
	self_kyc_error_aadhaar_otp_send: 'self_kyc_error_aadhaar_otp_send',
	self_kyc_error_aadhaar_invalid_otp: 'self_kyc_error_aadhaar_invalid_otp',
	self_kyc_error_aadhaar_mobile_linked: 'self_kyc_error_aadhaar_mobile_linked',
	self_kyc_error_aadhaar_duplicate: 'self_kyc_error_aadhaar_duplicate',
	self_kyc_error_aadhaar_mismatch: 'self_kyc_error_aadhaar_mismatch',
	self_kyc_send_otp: 'self_kyc_send_otp',
	self_kyc_subcode_success: 'self_kyc_subcode_success',
	self_kyc_subcode_change_details: 'self_kyc_subcode_change_details',
	self_kyc_subcode_retry: 'self_kyc_subcode_retry',
	self_kyc_subcode_call_product: 'self_kyc_subcode_call_product',
	self_kyc_subcode_conflict: 'self_kyc_subcode_conflict',
	self_kyc_subcode_duplicate: 'self_kyc_subcode_duplicate',
	self_kyc_error_msme_declaration: 'self_kyc_error_msme_declaration',
	self_kyc_error_address_proof_required: 'self_kyc_error_address_proof_required',
	self_kyc_error_address_proof_upload: 'self_kyc_error_address_proof_upload',
	self_kyc_error_poc_name: 'self_kyc_error_poc_name',
	self_kyc_error_poc_name_letters: 'self_kyc_error_poc_name_letters',
	self_kyc_error_mobile: 'self_kyc_error_mobile',
	self_kyc_error_email: 'self_kyc_error_email',
	self_kyc_error_farmart_email: 'self_kyc_error_farmart_email',
	self_kyc_error_poc_mobile_employee: 'self_kyc_error_poc_mobile_employee',
	self_kyc_error_poc_mobile_reused: 'self_kyc_error_poc_mobile_reused',
	self_kyc_error_merchant_mobile_mismatch:
		'self_kyc_error_merchant_mobile_mismatch',
	self_kyc_error_poc_already_exists: 'self_kyc_error_poc_already_exists',
	self_kyc_tds_loading: 'self_kyc_tds_loading',
	self_kyc_error_tds_load: 'self_kyc_error_tds_load',
	self_kyc_error_tds_submit: 'self_kyc_error_tds_submit',
	self_kyc_error_tds_already_exists: 'self_kyc_error_tds_already_exists',
	self_kyc_error_tds_not_draft: 'self_kyc_error_tds_not_draft',
	view_kyc_details: 'view_kyc_details',
	review_kyc_details: 'review_kyc_details',
	farmart_membership_card_title: 'farmart_membership_card_title',
	download_membership_card: 'download_membership_card',
	working_with_farmart: 'working_with_farmart',
	since: 'since',
	farmart_membership: 'farmart_membership',
	kyc_verified_badge: 'kyc_verified_badge',
	kyc_verified_message: 'kyc_verified_message',
	kyc_pending_badge: 'kyc_pending_badge',
	kyc_pending_message: 'kyc_pending_message',
	kyc_draft_message: 'kyc_draft_message',
	kyc_draft_subtext: 'kyc_draft_subtext',
	kyc_switch_draft_incomplete: 'kyc_switch_draft_incomplete',
	kyc_switch_consent_pending: 'kyc_switch_consent_pending',
	kyc_rejected_badge: 'kyc_rejected_badge',
	kyc_rejected_message: 'kyc_rejected_message',
	kyc_consent_pending_message: 'kyc_consent_pending_message',
	kyc_consent_rejected_message: 'kyc_consent_rejected_message',
	kyc_done_by_representative: 'kyc_done_by_representative',
	call: 'call',
	verification_pending: 'verification_pending',
	kyc_approved: 'kyc_approved',
	verification_rejected: 'verification_rejected',
	draft: 'draft',
	draft_inactive: 'draft_inactive',
	farmart_representative: 'farmart_representative',
	contact_Person_details: 'contact_Person_details',
	updated: 'updated',
	update_requested: 'update_requested',
	all_order_update_messages: 'all_order_update_messages',
	pan_details: 'pan_details',
	adhar_details: 'adhar_details',
	bank_account_details: 'bank_account_details',
	msme_details: 'msme_details',
	tds_certificate: 'tds_certificate',
	address_details: 'address_details',
	mandi_license_details: 'mandi_license_details',
	mandi_license_number: 'mandi_license_number',
	mandi_firm_name: 'mandi_firm_name',
	mandi_firm_address: 'mandi_firm_address',
	mandi_license_validity: 'mandi_license_validity',
	mandi_registered_mobile: 'mandi_registered_mobile',
	mandi_license_photo: 'mandi_license_photo',
	review_changes: 'review_changes',
	no_msme_message: 'no_msme_message',
	view_document: 'view_document',
	propretier_document: 'propretier_document',
	bussiness_not_registered_under_msme: 'bussiness_not_registered_under_msme',
	consent_pending_status: 'consent_pending_status',
	consent_rejected_status: 'consent_rejected_status',

	// KYC Overview field labels
	pan_number: 'pan_number',
	registered_business_name: 'registered_business_name',
	self_kyc_individual_name: 'self_kyc_individual_name',
	self_kyc_aadhaar_linked: 'self_kyc_aadhaar_linked',
	account_number: 'account_number',
	bank_name: 'bank_name',
	ifsc_code: 'ifsc_code',
	invalid_ifsc_code: 'invalid_ifsc_code',
	account_holder_name: 'account_holder_name',
	udyam_number: 'udyam_number',
	enterprise_name: 'enterprise_name',
	enterprise_type: 'enterprise_type',
	registration_date: 'registration_date',
	gstin: 'gstin',
	legal_name: 'legal_name',
	trade_name: 'trade_name',
	street: 'street',
	district: 'district',
	state: 'state',
	pincode: 'pincode',
	proprietor_document: 'proprietor_document',
	last_updated_on: 'last_updated_on',
	date_of_incorporation: 'date_of_incorporation',
	aadhaar_number: 'aadhaar_number',
	aadhaar_holder_name: 'aadhaar_holder_name',
	address_proof: 'address_proof',
	gst_number: 'gst_number',
	address: 'address',

	// Combined fields message
	combined_fields_message: 'combined_fields_message',
	only_updated_fields_message: 'only_updated_fields_message',
	only_added_fields_message: 'only_added_fields_message',

	// MSME Section
	proprietor_document_label: 'proprietor_document_label',
	view_document_button: 'view_document_button',

	// OldVsNew Section
	updated_details_chip: 'updated_details_chip',
	old_details_chip: 'old_details_chip',

	// KYC Consent Modal
	kyc_consent_pending: 'kyc_consent_pending',
	kyc_consent_pending_description: 'kyc_consent_pending_description',
	switch_and_continue: 'switch_and_continue',

	// SMS Send Success
	sms_send_success: 'sms_send_success',

	// Payment Terms Section
	payment_terms_title: 'payment_terms_title',
	payment_terms_loading: 'payment_terms_loading',
	payment_terms_unloading: 'payment_terms_unloading',
	payment_terms_buyer_claim: 'payment_terms_buyer_claim',
	payment_terms_percentage: 'payment_terms_percentage',
	payment_terms_buyer_claim_description_one:
		'payment_terms_buyer_claim_description_one',
	payment_terms_buyer_claim_description_two:
		'payment_terms_buyer_claim_description_two',
	payment_terms_buyer_claim_description_three:
		'payment_terms_buyer_claim_description_three',
	payment_terms_farmart: 'payment_terms_farmart',
	payment_terms_supplier: 'payment_terms_supplier',
	label_hash: 'label_hash',

	start_speaking: 'start_speaking',
	ai_listening: 'ai_listening',
	ask_with_voice: 'ask_with_voice',

	skip_login: 'skip_login',
	community_login_description: 'community_login_description',

	// User Trade Data Card
	your_farmart_journey: 'your_farmart_journey',
	quantity_traded: 'quantity_traded',
	truck_dispatched_label: 'truck_dispatched_label',
	amount_received: 'amount_received',
	tons: 'tons',
	payments_settled_within: 'payments_settled_within',
	view_my_orders: 'view_my_orders',

	// Farmart Trade Data Card (Overall Stats)
	trusted_by_suppliers: 'trusted_by_suppliers',
	tons_of_quantity_traded: 'tons_of_quantity_traded',
	payout_to_suppliers: 'payout_to_suppliers',
	we_are_here_to_help: 'we_are_here_to_help',
	have_a_question: 'have_a_question',

	//Faq languages
	rake_title: 'rake_title',
	rake_description: 'rake_description',
	rake_button_text: 'rake_button_text',
	bahi_khata_title: 'bahi_khata_title',
	bahi_khata_description: 'bahi_khata_description',
	bahi_khata_button_text: 'bahi_khata_button_text',
	shop_promotion_title: 'shop_promotion_title',
	shop_promotion_description: 'shop_promotion_description',
	shop_promotion_button_text: 'shop_promotion_button_text',
	trade_title: 'trade_title',
	trade_description: 'trade_description',
	trade_button_text: 'trade_button_text',
	my_sauda_title: 'my_sauda_title',
	my_sauda_description: 'my_sauda_description',
	my_sauda_button_text: 'my_sauda_button_text',
	community_title: 'community_title',
	community_description: 'community_description',
	community_button_text: 'community_button_text',
	distributor_title: 'distributor_title',
	distributor_description: 'distributor_description',
	distributor_button_text: 'distributor_button_text',
	hi: 'hi',
	select_a_category: 'select_a_category',
	share_what_you_are_looking_for: 'share_what_you_are_looking_for',
	ask_24_7_any_query: 'ask_24_7_any_query',
	ask_24_7: 'ask_24_7',
	frequent_asked_questions: 'frequent_asked_questions',
	faq: 'faq',
	was_it_helpful: 'was_it_helpful',
	great: 'great',
	please_contact_below: 'please_contact_below',
	open_now: 'open_now',
	closed_now: 'closed_now',
	talk_to_our_support_team: 'talk_to_our_support_team',
	talk_to_farmart_representative: 'talk_to_farmart_representative',
	get_priority_assistance: 'get_priority_assistance',
	call_support: 'call_support',
	ask_in_chat: 'ask_in_chat',
	ask_me_anything_placeholder: 'ask_me_anything_placeholder',
	support_hours: 'support_hours',
	mon_sat: 'mon_sat',
	feature_help_description: 'feature_help_description',
	step: 'step',
	login_via: 'login_via',
	get_orders_faster: 'get_orders_faster',
	add_your_confirmed_buyer_price: 'add_your_confirmed_buyer_price',
	already_agreed_with_your_buyer: 'already_agreed_with_your_buyer',
	how_it_works_request_sauda: 'how_it_works_request_sauda',
	request_sauda_screen_step_1: 'request_sauda_screen_step_1',
	request_sauda_screen_step_2: 'request_sauda_screen_step_2',
	request_sauda_screen_step_3: 'request_sauda_screen_step_3',
	quick_process: 'quick_process',
	proceed_to_request_sauda: 'proceed_to_request_sauda',
	login_via_whatsapp: 'login_via_whatsapp',

	// GST Summary
	gst_preparing_download: 'gst_preparing_download',
	gst_download_all_debit_notes: 'gst_download_all_debit_notes',
	gst_download_debit_note_pdf: 'gst_download_debit_note_pdf',
	gst_download_failed_message: 'gst_download_failed_message',
	gst_download_started_message: 'gst_download_started_message',
	gst_deductions: 'gst_deductions',
	gst_view_breakdown: 'gst_view_breakdown',
	gst_dispatch_orders: 'gst_dispatch_orders',
	gst_monthly_gst_summary: 'gst_monthly_gst_summary',
	gst_summary: 'gst_summary',
	gst_intro_description: 'gst_intro_description',
	gst_intro_got_it: 'gst_intro_got_it',
	gst_intro_badge_new: 'gst_intro_badge_new',

	gst_label_payable: 'gst_label_payable',
	gst_label_deductions: 'gst_label_deductions',
	gst_label_gst_payable: 'gst_label_gst_payable',
	gst_no_orders_done: 'gst_no_orders_done',
	gst_payable_with_amount: 'gst_payable_with_amount',
	gst_no_past_months_found: 'gst_no_past_months_found',
	gst_no_summary_yet: 'gst_no_summary_yet',
	gst_no_summary_yet_description: 'gst_no_summary_yet_description',
	gst_footer_disclaimer: 'gst_footer_disclaimer',
	gst_summary_with_month: 'gst_summary_with_month',
	gst_payable_order_value: 'gst_payable_order_value',
	gst_order_deductions: 'gst_order_deductions',
	gst_gst_applicable_on: 'gst_gst_applicable_on',
	gst_invoice_number: 'gst_invoice_number',
	gst_do_number: 'gst_do_number',
	gst_gst_applicable_on_label: 'gst_gst_applicable_on_label',
	gst_no_deductions: 'gst_no_deductions',
	gst_banner_alt: 'gst_banner_alt',
	gst_close: 'gst_close',
	rake_update_delayed: 'rake_update_delayed',
	rake_delay_agri_inputs: 'rake_delay_agri_inputs',
	rake_delay_food_grain: 'rake_delay_food_grain',
	rake_delay_message: 'rake_delay_message',
	rake_delay_intro: 'rake_delay_intro',
	rake_delay_agri_input_for_date: 'rake_delay_agri_input_for_date',
	rake_delay_food_grain_for_date: 'rake_delay_food_grain_for_date',
	rake_delay_footer: 'rake_delay_footer',
	update_gst_details_anytime_title: 'update_gst_details_anytime_title',
	update_gst_details_anytime_subtitle: 'update_gst_details_anytime_subtitle',
	update_gst_details_button: 'update_gst_details_button',
	update_gst_address_button: 'update_gst_address_button',
	update_gst_details_section: 'update_gst_details_section',
	update_gst_linked_with_pan: 'update_gst_linked_with_pan',
	update_gst_address_section: 'update_gst_address_section',
	add_gst_details: 'add_gst_details',
	select_gst: 'select_gst',
	add_pan_details: 'add_pan_details',
	pan_number_should_be_10_characters: 'pan_number_should_be_10_characters',
	pan_placeholder: 'pan_placeholder',
	confirm_pan: 'confirm_pan',
	change_pan: 'change_pan',
	pan_verification_in_progress: 'pan_verification_in_progress',
	pan_verification_please_wait: 'pan_verification_please_wait',
	pan_required_to_add_gst: 'pan_required_to_add_gst',
	please_enter_pan_before_adding_gst: 'please_enter_pan_before_adding_gst',
	enter_pan: 'enter_pan',
	add_gst_address: 'add_gst_address',
	select_active_gst_associated_with_pan: 'select_active_gst_associated_with_pan',
	update_address_linked_with_gst: 'update_address_linked_with_gst',
	confirm: 'confirm',
	active: 'active',
	inactive: 'inactive',
	business_name_from_pan: 'business_name_from_pan',
	update_bank_account_section: 'update_bank_account_section',
	update_bank_details_anytime_title: 'update_bank_details_anytime_title',
	update_bank_details_anytime_subtitle: 'update_bank_details_anytime_subtitle',
	update_bank_details_button: 'update_bank_details_button',
	bank_account_change_not_allowed_title: 'bank_account_change_not_allowed_title',
	bank_account_change_not_allowed_message:
		'bank_account_change_not_allowed_message',
	bank_account_change_individual_title: 'bank_account_change_individual_title',
	bank_account_change_individual_message:
		'bank_account_change_individual_message',
	kyc_poc_updated_message: 'kyc_poc_updated_message',
	update_details_new_badge: 'update_details_new_badge',
	add_gst: 'add_gst',
	add_msme: 'add_msme',
	add_msme_details_title: 'add_msme_details_title',
	udyam_registration_number: 'udyam_registration_number',
	udyam_placeholder: 'udyam_placeholder',
	how_to_find_udyam_number: 'how_to_find_udyam_number',
	msme_verification_in_progress: 'msme_verification_in_progress',
	mandi_license_verification_in_progress:
		'mandi_license_verification_in_progress',
	msme_verification_please_wait: 'msme_verification_please_wait',
	confirm_msme: 'confirm_msme',
	change_msme: 'change_msme',
	invalid_udyam_number: 'invalid_udyam_number',
	msme_inactive_error: 'msme_inactive_error',
	change_account: 'change_account',
	status: 'status',
	msme_request_submitted_successfully: 'msme_request_submitted_successfully',
	gst_updated_successfully: 'gst_updated_successfully',
	kyc_bank_details_updated_message: 'kyc_bank_details_updated_message',
	kyc_bank_update_request_submitted_message:
		'kyc_bank_update_request_submitted_message',
	bank_verification_in_progress: 'bank_verification_in_progress',
	getting_addresses_from_gst: 'getting_addresses_from_gst',
	updating_gst_details: 'updating_gst_details',
	verification_please_wait: 'verification_please_wait',
	gst_address_updated_successfully: 'gst_address_updated_successfully',
	gst_pan_details_update_requested_successfully:
		'gst_pan_details_update_requested_successfully',
	gst_already_exists_in_farmart: 'gst_already_exists_in_farmart',
	gst_change_not_allowed_title: 'gst_change_not_allowed_title',
	gst_change_not_allowed_message: 'gst_change_not_allowed_message',
	no_gst_linked_with_pan: 'no_gst_linked_with_pan',
	all_gst_linked_with_pan_inactive: 'all_gst_linked_with_pan_inactive',
	could_not_load_gst_list: 'could_not_load_gst_list',
	could_not_load_gst_address_list: 'could_not_load_gst_address_list',
	no_gst_addresses_title: 'no_gst_addresses_title',
	no_gst_addresses_message: 'no_gst_addresses_message',
	gst_address_change_not_allowed_title: 'gst_address_change_not_allowed_title',
	gst_address_change_not_allowed_message:
		'gst_address_change_not_allowed_message',
	closeOnly: 'closeOnly',

	// Pending Dispatch Card
	dispatch_pending_badge: 'dispatch_pending_badge',
	dispatch_pending_for_n_orders: 'dispatch_pending_for_n_orders',
	view_purchase_orders: 'view_purchase_orders',
	oldest_po_from: 'oldest_po_from',
	create_truck_dispatch: 'create_truck_dispatch',
	po_created_ago: 'po_created_ago',
	pending_dispatch_modal_title: 'pending_dispatch_modal_title',
	n_pending_badge: 'n_pending_badge',

	// Pending Unloading Card
	upload_required_badge: 'upload_required_badge',
	upload_unloading_documents_title: 'upload_unloading_documents_title',
	add_unloading: 'add_unloading',
	documents_pending_for_n_trucks: 'documents_pending_for_n_trucks',
	view_pending_trucks: 'view_pending_trucks',
	requires_grn_weight_slip: 'requires_grn_weight_slip',
	ton: 'ton',
	upload_documents: 'upload_documents',
	pending_unloading_modal_title: 'pending_unloading_modal_title',
	n_trucks_badge: 'n_trucks_badge',

	// Add Unloading Sheet
	do_quantity: 'do_quantity',
	rejected_please_reupload: 'rejected_please_reupload',
	reupload_documents_title: 'reupload_documents_title',

	// Doc Upload Sheet
	cancel_upload_heading: 'cancel_upload_heading',
	cancel_upload_confirmation: 'cancel_upload_confirmation',
	upload_button: 'upload_button',

	// Dispatch Rejected Card
	update_dispatch: 'update_dispatch',
	dispatch_doc_rejected_badge: 'dispatch_doc_rejected_badge',
	dispatch_documents_rejected_for_n_orders:
		'dispatch_documents_rejected_for_n_orders',
	view_all: 'view_all',
	re_upload_dispatch_documents: 're_upload_dispatch_documents',
	dispatch_rejected_modal_title: 'dispatch_rejected_modal_title',
	n_rejected_badge: 'n_rejected_badge',

	// Unloading Rejected Card
	update_unloading: 'update_unloading',
	unloading_doc_rejected_badge: 'unloading_doc_rejected_badge',
	unloading_documents_rejected_for_n_trucks:
		'unloading_documents_rejected_for_n_trucks',
	re_upload_unloading_documents: 're_upload_unloading_documents',
	unloading_rejected_modal_title: 'unloading_rejected_modal_title',
	// Switch Profile Card & Modal
	switch_business_profile: 'switch_business_profile',
	switch_profile_card_pending_dispatch: 'switch_profile_card_pending_dispatch',
	switch_profile_card_dispatch_rejected: 'switch_profile_card_dispatch_rejected',
	switch_profile_card_pending_unloading: 'switch_profile_card_pending_unloading',
	switch_profile_card_unloading_rejected:
		'switch_profile_card_unloading_rejected',

	// Leaderboard
	leaderboard: 'leaderboard',
	overall_rank_india: 'overall_rank_india',
	my_rank: 'my_rank',
	quizzes_count: 'quizzes_count',
	you_are_in_top: 'you_are_in_top',
	your_rank: 'your_rank',
	total_wins: 'total_wins',
	accuracy: 'accuracy',
	quizzes_played: 'quizzes_played',
	top: 'top',
	total_participants: 'total_participants',
	no_leaderboard_data: 'no_leaderboard_data',
	complete_quizzes_to_appear: 'complete_quizzes_to_appear',
	view_winnerboard: 'view_winnerboard',
};
